module.exports = __webpack_public_path__ + "img/Weapon_24.cd47a220.png";